<template>
  <div>
    <h4 class="page-title">입/퇴사 사원 관리</h4>

    <employee-list />
  </div>
</template>
<script>
  import EmployeeList from "@/components/user/employee/index/EmployeeList";

  export default {
    components: {
      EmployeeList
    }
  }
</script>
